import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IGeneratePasswordResetTokenParams {
  username: string;
}

export interface IGeneratePasswordResetTokenResult extends IResult {
}

export class GeneratePasswordResetTokenRequest extends Request<IGeneratePasswordResetTokenParams, IGeneratePasswordResetTokenResult> {
  constructor(params: IGeneratePasswordResetTokenParams) {
    super('generatePasswordResetToken', params);
  }
}
